<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const { reset } = useSlpParams(sellingMethod);
</script>

<template>
    <div class="my-24 flex aspect-4/3 w-full flex-col items-center justify-center gap-3 text-center md:aspect-8/3 xl:aspect-12/3">
        <SvgoSteeringWheel class="h-16" filled :font-controlled="false" />
        <p class="text-dimmed text-2xl font-semibold">
            {{ tt(`slp.${sellingMethod}.page.emptyStateTitle`) }}
        </p>
        <p class="md:text-lg">
            {{ tt(`slp.${sellingMethod}.page.emptyStateText`) }}
        </p>
        <UButton variant="outline" size="xl" color="neutral" :label="tt(`slp.page.resetFilters`)" @click="reset" />
    </div>
</template>
